export const sport = process.env.REACT_APP_SPORT ?? "studio";
export const appName = process.env.REACT_APP_NAME ?? "Studio";
export const googleStoreLink = process.env.REACT_APP_GOOGLE_STORE_LINK ?? "";
export const appleStoreLink = process.env.REACT_APP_APPLE_STORE_LINK ?? "";
